import BannerAd from './BannerAd.js';

class BannerAdTopboard extends BannerAd {
    render() {
        if (this._adObj.banner.height < 150) {
            const container = document.querySelector(
                "div[data-astbanner-name='topboard']"
            );
            container.style.cssText = 'text-align: center;';
        }
    }
}

export default BannerAdTopboard;



// WEBPACK FOOTER //
// ./services/banner2/types/BannerAdTopboard.js